/**
 * Confirmation Modal System
 * Replaces blocking confirm() dialogs with non-blocking custom modals
 */

import { escapeHtml } from './ui-helpers.js';

/**
 * Show a confirmation dialog
 * @param {string} message - Message to display
 * @param {Function} onConfirm - Callback when user confirms
 * @param {Object} options - Optional configuration
 * @param {string} options.confirmText - Text for confirm button (default: 'Confirm')
 * @param {string} options.cancelText - Text for cancel button (default: 'Cancel')
 */
export function showConfirmDialog(message, onConfirm, options = {}) {
  const {
    confirmText = 'Confirm',
    cancelText = 'Cancel'
  } = options;

  const modal = document.createElement('div');
  modal.className = 'confirm-modal';
  modal.innerHTML = `
    <div class="modal-backdrop"></div>
    <div class="modal-content">
      <p>${escapeHtml(message)}</p>
      <div class="modal-actions">
        <button class="btn-cancel">${escapeHtml(cancelText)}</button>
        <button class="btn-confirm">${escapeHtml(confirmText)}</button>
      </div>
    </div>
  `;

  const cleanup = () => {
    modal.remove();
    document.removeEventListener('keydown', handleEsc);
  };

  modal.querySelector('.btn-confirm').onclick = () => {
    cleanup();
    onConfirm();
  };

  modal.querySelector('.btn-cancel').onclick = cleanup;
  modal.querySelector('.modal-backdrop').onclick = cleanup;

  // ESC key to cancel
  const handleEsc = (e) => {
    if (e.key === 'Escape') {
      cleanup();
    }
  };
  document.addEventListener('keydown', handleEsc);

  document.body.appendChild(modal);

  // Focus cancel button for accessibility
  setTimeout(() => modal.querySelector('.btn-cancel').focus(), 100);
}
